import React, { Component } from "react";
import { Link } from "react-router-dom";

// Layout
import Header from "../layout/header/header1";

// Images
import bannerImg from "../../images/banner/banner3.jpg";
import news15_1 from "../../images/news/news15_1.png";
import news15_2 from "../../images/news/news15_2.png";

import { withTranslation } from "react-i18next";
import ReactMarkdown from "react-markdown";

class news15 extends Component {
    componentDidMount() {}

    componentWillMount() {
        const { t } = this.props;
        document.getElementById("title").innerText = t("News15_Title");
    }

    componentWillUnmount() {
        const { t } = this.props;
        document.getElementById("title").innerText = t("Home_Title");
    }

    render() {
        const { t } = this.props;

        return (
            <>
                <Header />

                <div className="page-content">
                    <div
                        className="page-banner ovbl-dark"
                        style={{ backgroundImage: "url(" + bannerImg + ")" }}
                    >
                        <div className="container">
                            <div className="page-banner-entry">
                                <h1 className="text-white">{t("News15_Title")}</h1>
                            </div>
                        </div>
                    </div>

                    <div className="breadcrumb-row">
                        <div className="container">
                            <ul className="list-inline">
                                <li>
                                    <Link to="/">{t("News15_LinkHome")}</Link>
                                </li>
                                <li>{t("News15_LinkCourses")}</li>
                            </ul>
                        </div>
                    </div>

                    <div className="content-block">
                        <div className="section-area section-sp1">
                            <div className="container">
                                <div className="row d-flex flex-row-reverse">
                                    <div className="col-xl-9 col-lg-8 col-md-12 col-sm-12">
                                        <div className="courses-post">

                                            {/* Title */}
                                            <h1>{t("News15_Content_H")}</h1>

                                            {/* P1 */}
                                            <ReactMarkdown>{t("News15_P1_MD")}</ReactMarkdown>

                                            {/* IMG 1 */}
                                            <div style={{ textAlign: "center", margin: "20px 0" }}>
                                                <img
                                                    src={news15_1}
                                                    alt={t("News15_IMG1_DESC")}
                                                />
                                                <div
                                                    style={{
                                                        marginTop: "10px",
                                                        fontStyle: "italic",
                                                        color: "#555",
                                                    }}
                                                >
                                                    {t("News15_IMG1_DESC")}
                                                </div>
                                            </div>

                                            {/* P2 */}
                                            <ReactMarkdown>{t("News15_P2_MD")}</ReactMarkdown>

                                            {/* IMG 2 */}
                                            <div style={{ textAlign: "center", margin: "20px 0" }}>
                                                <img
                                                    src={news15_2}
                                                    alt={t("News15_IMG2_DESC")}
                                                />
                                                <div
                                                    style={{
                                                        marginTop: "10px",
                                                        fontStyle: "italic",
                                                        color: "#555",
                                                    }}
                                                >
                                                    {t("News15_IMG2_DESC")}
                                                </div>
                                            </div>

                                            {/* P3 */}
                                            <ReactMarkdown>{t("News15_P3_MD")}</ReactMarkdown>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default news15 = withTranslation()(news15);
